// extracted by mini-css-extract-plugin
module.exports = {"preLink":"detailsGdd-module--pre-link--LgjLK","detailsGdd":"detailsGdd-module--details-gdd--1-6CZ"};